export default {
  data () {
    return {
      isShow: false,
      settings: null,
    }
  },

  methods: {
    configureSettings() {
      let config = {},
        inputItem,
        disclaimerMessage,
        label
      switch (this.autoCampaign.type) {
        case 1:
          this.addSettingsTrue('setTime', config)
          config.type = 'birthday'
          break;
        case 4:
          this.addSettingsTrue('hasMinMax', config)
          this.addSettingsTrue('setTime', config)
          this.configureWinBack(config)
          config.type = 'win-back'
          break;
        case 5:
          this.addSettingsTrue('setTime', config)
          label = '# of days after visit'
          inputItem = {
            class: 'form-control type_5',
            for: 'argument_1',
            inputType: 'number',
            label: label,
            noInteraction: !this.autoCampaign.argument_1,
            value: this.autoCampaign.argument_1
          }
          this.configureOnlyArgument1(label, inputItem, config)
          config.type = 'delayed-after-visit'
          break;
        case 6:
          this.addSettingsTrue('setTime', config)
          label = 'day of the week'
          inputItem = {
            class: 'form-control type_5',
            for: 'argument_1',
            inputType: 'select',
            label: label,
            noInteraction: !this.autoCampaign.argument_1,
            options: [
              { text: 'sunday', value: 0 },
              { text: 'monday', value: 1 },
              { text: 'tuesday', value: 2 },
              { text: 'wednesday', value: 3 },
              { text: 'thursday', value: 4 },
              { text: 'friday', value: 5 },
              { text: 'saturday', value: 6 },
            ],
            value: this.autoCampaign.argument_1
          }
          this.configureOnlyArgument1(label, inputItem, config)
          config.type = 'daily-deals'
          break;
        case 11:
          this.addSettingsTrue('hasAddConfiguration', config)
          label = 'spend milestone'
          inputItem = {
            class: 'form-control currency',
            for: 'argument_1',
            inputStep: '0.01',
            inputType: 'number',
            isCurrency: true,
            label: label,
            noInteraction: !this.autoCampaign.argument_1,
            placeHolder: '0.00',
            value: this.autoCampaign.argument_1
          }
          this.configureAddConfiguration(label, inputItem, config)
          config.type = 'spend-milestone'
          break;
        case 12:
          this.addSettingsTrue('hasAddConfiguration', config)
          label = 'visit milestone'
          inputItem = {
            class: 'form-control currency',
            for: 'argument_1',
            inputType: 'number',
            isCurrency: true,
            label: label,
            noInteraction: !this.autoCampaign.argument_1,
            value: this.autoCampaign.argument_1
          }
          this.configureAddConfiguration(label, inputItem, config)
          config.type = 'visit-milestone'
          break;
        case 13:
          label = 'big purchase milestone'
          inputItem = {
            class: 'form-control currency',
            for: 'argument_1',
            inputStep: '0.01',
            inputType: 'number',
            isCurrency: true,
            label: label,
            noInteraction: !this.autoCampaign.argument_1,
            value: this.autoCampaign.argument_1
          }
          this.configureOnlyArgument1(label, inputItem, config)
          config.type = 'big-purchase'
          break;
        case 14:
          config.type = 'after-visit';
          break;
        case 15:
          this.addSettingsTrue('setTime', config)
          inputItem = {
            class: 'form-control',
            for: 'argument_1',
            inputStep: '1',
            inputType: 'number',
            label: 'days from join',
            noInteraction: !this.autoCampaign.argument_1,
            placeholder: 0,
            value: this.autoCampaign.argument_1
          }
          this.configureOnlyArgument1('days after join', inputItem, config)
          config.type = 'join-date'
          break;
        case 16:
          this.configureReferral(config)
          config.type = 'referral'
          break;
        case 17:
          this.addSettingsTrue('setTime', config)
          label = '# of days prior to expiration'
          inputItem = {
            class: 'form-control type_17',
            for: 'argument_1',
            inputType: 'number',
            label: label,
            noInteraction: !this.autoCampaign.argument_1,
            value: this.autoCampaign.argument_1
          }
          this.configureOnlyArgument1(label, inputItem, config)
          config.type = 'medical-card-expiration'
          break;
        case 19:
          label = 'hours until message sent'
          disclaimerMessage = "If a cart is abandoned after compliance hours (merchant’s local time), this message will send to the member at the next available time"
          inputItem = {
            class: 'form-control',
            for: 'argument_1',
            inputStep: '1',
            inputType: 'number',
            min: 1,
            max: 744,
            label: label,
            noInteraction: !this.autoCampaign.argument_1,
            value: this.autoCampaign.argument_1
          }
          this.configureOnlyArgument1(label, inputItem, config)
          this.configureDisclaimer(disclaimerMessage, config)
          config.type = 'abandoned-cart'
          break;
        case 20:
          this.addSettingsTrue("setTime", config)
          this.addSettingsTrue("setBrand", config)
          this.addSettingsTrue("setFrequency", config)
          this.addSettingsTrue("setDateRange", config)
          this.addSettingsTrue("setSendDay", config)
          config.type = "brand-follow-up"
          break;
        case 22:
          label = 'days prior to expiration'
          inputItem = {
            class: 'form-control type_22',
            for: 'argument_1',
            inputType: 'number',
            min: 1,
            inputStep: '1',
            label: label,
            noInteraction: !this.autoCampaign.argument_1,
            value: this.autoCampaign.argument_1
          }
          this.configureOnlyArgument1(label, inputItem, config)
          config.type = 'points-expiration-reminder'
          this.addSettingsTrue("setTime", config)
          break;

        }
      this.settings = config.type ? config : null
    },

    addSettingsTrue(settingsKey, settingsObject) {
      return settingsObject[settingsKey] = true
    },

    configureAddConfiguration(label, inputItem, settingsObject) {
      const circumventLabel = 'send after visit sms for this transaction?',
        arg2 = this.autoCampaign.argument_2
      if (this.isShow) {
        settingsObject.showLabels = arg2 ? [label, 'additional configuration', circumventLabel] : [label]
      } else {
        settingsObject.inputItem = inputItem
        settingsObject.timeframeInput = {
          class: 'form-control',
          for: 'argument_2',
          inputType: 'number',
          label: 'within timeframe (days)',
          value: arg2
        }
        settingsObject.circumventSelect = {
          class: 'form-control',
          for: 'argument_3',
          inputType: 'select',
          label: circumventLabel,
          options: [
            { text: 'yes', value: '' },
            { text: 'no', value: 'true' },
          ],
          value: this.autoCampaign.argument_3
        }
        settingsObject.interactionsToSet = ['argument_1']
      }
    },

    configureOnlyArgument1(label, inputItem, settingsObject) {
      if (this.isShow) {
        settingsObject.showLabels = [label]
      } else {
        settingsObject.inputItem = inputItem
        settingsObject.interactionsToSet = ['argument_1']
      }
    },

    configureReferral(settingsObject) {
      const selectLabel = 'count referral as',
        arg1 = this.autoCampaign.argument_1,
        showAllLabels = arg1 === '3'
      if (this.isShow) {
        const arg2Label = showAllLabels ? 'min purchase amount' : null
        settingsObject.showLabels = [selectLabel, arg2Label, 'referrals allowed per member']
      } else {
        settingsObject.openValue = '3'
        settingsObject.selectBox = {
          class: 'form-control type_5 referral-select',
          id: 'argument_1',
          inputType: 'select',
          labelText: selectLabel,
          options: [
            { text: 'referred join', value: 2 },
            { text: 'referred purchase', value: 3 },
          ],
          value: arg1,
        }
        settingsObject.toggleInput = {
          class: 'form-control currency optional',
          id: 'argument_2',
          inputStep: '0.01',
          inputType: 'number',
          isCurrency: true,
          labelText: 'min purchase',
          placeHolder: '0.00',
          value: this.autoCampaign.argument_2,
          optional: true,
        }
        settingsObject.toggleRadio = {
          for: 'argument_3',
          inputId: 'argument_3',
          label: 'member referral limit',
          radios: [{label: 'unlimited', ref: 'noInput', value: -1}, {label: 'limited', ref: 'input', value: ''}],
          savedInputValue: this.autoCampaign.argument_3,
          valueLabel: 'referrals per member',
        }
        settingsObject.interactionsToSet = ['argument_1']
      }
    },

    configureWinBack(settingsObject) {
      const minLabel = 'min days since visit',
        maxLabel = 'max days since visit'
      if (this.isShow) {
        settingsObject.throttleLabel = 'send frequency (days)'
        settingsObject.showLabels = [minLabel, maxLabel]
      } else {
        settingsObject.maxInput = {
          class: 'form-control',
          id: 'argument_2',
          inputType: 'number',
          labelText: maxLabel,
          value: this.autoCampaign.argument_2
        }
        settingsObject.minInput = {
          class: 'form-control type_5, type_4',
          id: 'argument_1',
          inputType: 'number',
          labelText: minLabel,
          value: this.autoCampaign.argument_1
        }
        settingsObject.toggleRadio = {
          for: 'throttle',
          inputId: 'throttle',
          label: 'send frequency',
          radios: [{label: 'once', ref: 'noInput', value: -1}, {label: 'multiple', ref: 'input', value: ''}],
          savedInputValue: this.autoCampaign.throttle,
          spanAfterText: 'days',
          spanBeforeText: 'every',
        }
        settingsObject.interactionsToSet = ['argument_1', 'argument_2']
      }
    },
    configureDisclaimer(disclaimer, settingsObject) {
      settingsObject.disclaimer = disclaimer
    }
  },
}
